import {
  FirestoreDataConverter,
  DocumentSnapshot,
  SnapshotOptions,
  WithFieldValue,
} from "firebase/firestore";
import { Company } from "../user";

const companyConverter: FirestoreDataConverter<Company> = {
  toFirestore(company: WithFieldValue<Company>) {
    const { id, ...data } = company;
    return data;
  },
  fromFirestore(snapshot: DocumentSnapshot, options: SnapshotOptions): Company {
    const data = snapshot.data(options);

    if (!data)
      return {
        id: snapshot.id,
        name: "",
        entity_structure: "",
        primary_contact_user_id: "",
        date_created: new Date().toISOString(),
        date_modified: new Date().toISOString(),
        created_by: "",
        is_active: true,
        user_ids: [],
      };

    return {
      id: snapshot.id,
      name: data.name || "",
      entity_structure: data.entity_structure || "",
      federal_tax_id: data.federal_tax_id,
      business_start_date: data.business_start_date,
      primary_contact_user_id: data.primary_contact_user_id || "",
      address: data.address || {
        street: "",
        city: "",
        state: "",
        zipCode: "",
        country: "",
      },
      phone: data.phone,
      email: data.email,
      website: data.website,
      industry: data.industry,
      employee_count: data.employee_count,
      annual_revenue: data.annual_revenue,
      date_created: data.date_created || new Date().toISOString(),
      date_modified: data.date_modified || new Date().toISOString(),
      created_by: data.created_by || "",
      is_active: data.is_active !== undefined ? data.is_active : true,
      notes: data.notes,
      user_ids: data.user_ids || [],
      user_financing_profile_assignments:
        data.user_financing_profile_assignments || {},
    };
  },
};

export { companyConverter }; 